import { render, staticRenderFns } from "./github.vue?vue&type=template&id=053c9538&scoped=true&"
import script from "./github.vue?vue&type=script&lang=js&"
export * from "./github.vue?vue&type=script&lang=js&"
import style0 from "./github.vue?vue&type=style&index=0&id=053c9538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c9538",
  null
  
)

export default component.exports